import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, SmartphoneIcon } from 'lucide-react';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-label="Bonuses" className="border-y border-grape-soft/30 bg-white/70" data-id="element-17" data-mp="av34oprykyzk">
      <div className="mx-auto max-w-5xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "22px"
    }} data-id="element-18" data-mp="at8ua5ebcp9q">
        <h2 className="text-center font-display text-2xl font-black uppercase text-plum sm:text-4xl" data-id="element-19" data-mp="1tvktcq6w0p0">
          🎁 5 Professional Bonuses Included
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm font-bold uppercase tracking-wide text-grape" data-id="element-20" data-mp="5tvxosxn43ty">
          Available with your complete SIGMA SMART™ package
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-21" data-mp="3t1817pj90a3v">
          {bonuses.map((b, i) => <motion.div key={b.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`relative flex w-full gap-4 rounded-2xl border border-grape-soft/50 bg-cream p-5 ${i === bonuses.length - 1 && bonuses.length % 2 === 1 ? 'sm:col-span-2 sm:max-w-[calc(50%-10px)] sm:justify-self-center' : ''}`} data-id="element-22" data-mp="1mb9w31213ijd" data-mpi={i}>
              <img src={b.cover} alt={`${b.title} bonus cover`} width={1122} height={1402} loading="lazy" decoding="async" sizes="112px" className="h-auto w-24 shrink-0 self-start object-contain drop-shadow-[0_10px_18px_rgba(0,0,0,0.3)] sm:w-28" data-id="element-23" data-mp="2zfaquewxe3m2" />
              <div className="flex min-w-0 flex-col" data-id="element-24" data-mp="38htnuie15m0e">
                <div className="mb-3 flex flex-wrap items-center justify-between gap-2" data-id="element-25" data-mp="33gnvwms722rx">
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-plum px-3 py-1 text-xs font-bold text-grape-soft" data-id="element-26" data-mp="nprl7bkw0vmq">
                    <GiftIcon className="h-3.5 w-3.5" data-id="element-27" data-mp="iqf1gzpbc4od" /> Bonus {b.n}
                  </span>
                  <span className="whitespace-nowrap text-sm font-bold" data-id="element-28" data-mp="3ciell2ggpsyk">
                    <span className="text-plum/45" data-id="element-29" data-mp="3hh8110fb7u1d">Value </span>
                    <span className="text-plum/45 line-through" data-id="element-30" data-mp="3ljl5llibllwk">{b.price}</span>{' '}
                    <span className="text-grape" data-id="element-31" data-mp="3lhi9cjqkqwje">FREE</span>
                  </span>
                </div>
                <h3 className="text-base font-bold text-plum" data-id="element-32" data-mp="3qgbjq3ake7fc">{b.title}</h3>
                <p className="mt-1.5 text-sm font-semibold leading-snug text-plum/80" data-id="element-33" data-mp="2tu9nobmhl27o">{b.tagline}</p>
                <p className="mt-1.5 text-sm leading-relaxed text-plum/65" data-id="element-34" data-mp="2xua2hxdhzff9">{b.desc}</p>
              </div>
            </motion.div>)}
        </div>

        

        <div className="mt-6 rounded-2xl bg-plum px-6 py-3 text-center" data-id="element-35" data-mp="37kd0yd3e1lkz">
          <p className="text-base font-bold text-white sm:text-lg" data-id="element-36" data-mp="2a4fqtj4wzwwl">
            💰 Total Bonus Value: <span className="text-white/50 line-through" data-id="element-37" data-mp="2a2ldoqzvx932">$152</span>{' '}
            <span className="text-[15px] text-grape-soft" data-id="element-38" data-mp="2f1xxt3zdg21y">TODAY FREE WITH THE 6 IN 1 COMBO</span>
          </p>
        </div>
      </div>
    </section>;
}